import { observer } from 'mobx-react';
import { when } from '@execonline-inc/maybe-adapter';
import InvitationsStore from '../Store';
import { InvitationsResource } from '../Store/Types';
import { hasResults } from '../../../../Pagination/pagination';
import { emptyFragment } from '../../../../../EmptyFragment';
import LoadMore from '../../../../Pagination/LoadMore';

interface Props {
  store: InvitationsStore;
  invitationsResource: InvitationsResource;
}

function Pagination({ store, invitationsResource }: Props) {
  return when(hasResults(invitationsResource.metadata), invitationsResource.metadata)
    .map((metadata) => (
      <div className="py-5">
        <LoadMore
          metadata={metadata}
          pageFn={store.loadingMore}
          displayedCount={store.displayedCount}
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Pagination);
